import { defineModule } from '@/app/router/defineModule.ts';
import TeamSidebar from '#modules/team/components/TeamSidebar.vue';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'team',
    routes: [
        {
            path: '/team',
            meta: {
                layout: 'app-sidebar',
                sidebar: TeamSidebar,
                middleware: [shouldBeAuthenticated, ensureUserIsVerified],
            },
            children: [
                {
                    path: '',
                    name: 'team',
                    component: () => import('#modules/team/pages/index.vue'),
                },
                {
                    path: 'edit',
                    name: 'edit team',
                    component: () => import('#modules/team/pages/edit.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageTeams],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'team-members',
                    name: 'team members',
                    component: () => import('#modules/team/pages/team-members.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageTeams],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'default-language',
                    name: 'team default language',
                    component: () => import('#modules/team/pages/default-language.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageTeams],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'direct-debit',
                    name: 'team direct debit',
                    component: () => import('#modules/team/pages/direct-debit.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageTeamPayments],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'slack-integration',
                    name: 'team slack integration',
                    component: () => import('#modules/team/pages/slack-integration.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageNotificationSettings],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'notifications',
                    name: 'team notifications',
                    component: () => import('#modules/team/pages/notifications.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageNotificationSettings],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'two-factor-authentication',
                    name: 'team two factor authentication',
                    component: () => import('#modules/team/pages/two-factor-authentication.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageTeams],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'activity-log',
                    name: 'team activity log',
                    component: () => import('#modules/team/pages/activity-log.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageTeams, AppPermissions.ManageActivities],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'ssh-keys',
                    name: 'team ssh keys',
                    component: () => import('#modules/team/pages/ssh-keys.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageWebOpsSshKeys],
                        middleware: [enforceTwoFactor],
                    },
                },
                {
                    path: 'subscriptions',
                    name: 'subscriptions',
                    component: () => import('#modules/team/pages/subscriptions.vue'),
                    meta: {
                        permissions: [AppPermissions.ManageFinancial],
                    },
                },
            ],
        },
    ],
});
